import { type Experimental_DefaultFormStateBehavior } from '@rjsf/utils'
import { customizeValidator } from '@rjsf/validator-ajv8'

export const wizardValidator = customizeValidator({ ajvOptionsOverrides: { unicodeRegExp: false } })

export const WIZARD_DEFAULTS_BEHAVIOR: Experimental_DefaultFormStateBehavior = { constAsDefaults: 'skipOneOf' }
